
<template>
  <div class="">
    <el-container>
      <el-main>
        <div class="box">
          <div class="left">
            <div v-for="(item,index) in msg" :key="index" class="leftItem" @click="ChangClick(index)" :class="{liBackground:clickIndex==index}">
              <div>{{ item.title }}</div>
            </div>
          </div>
          <div class="right1">
            <div  v-show="clickIndex===0">
              <el-form label-width="100px">
                <el-form-item label="卡类型：">
                  <el-button disabled>ICCID</el-button>
                </el-form-item>
                <el-form-item label="物联网卡号：">
                  <el-input type="textarea" :rows="10" name="content" id="content" v-model="iccids" placeholder="请输入号码（卡号之间以换行隔开）" style="width:89%;height: 200px;margin-bottom: 20px;"></el-input>
                </el-form-item>
                <div style="display: flex;">
                  <el-form-item label="控制类型 *">
                    <el-select @change="sel_change" filterable allow-create default-first-option v-model="card_route.cd_control_type" placeholder="请选择">
                      <el-option v-for="item in cd_control_type_option" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="断网阈值 *" v-show="!option_bool">
                    <el-input type="number" v-model.trim="card_route.is_max_use"  placeholder="如 50MB 阈值输入：50" />
                  </el-form-item>

                  <el-form-item label="限速规则 *" v-show="option_bool">
                    <el-input v-model.trim="card_route.is_limit_rules" placeholder="如: 10=4,20=1(单位MB)" />
                  </el-form-item>
                  <el-form-item>
                    <el-button style="margin-left: -100%" @click="funAdd" type="primary" size="small" plain>更新</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <!-- 上传表格 -->
            <div v-show="clickIndex===1">
              <el-form label-width="100px">
                <el-form-item label="卡类型：">
                  <el-button disabled>ICCID</el-button>
                </el-form-item>
                <el-form-item label="下载模板：">
                  <el-button><a :href="importUrl"><span style="color:#333;">导入模板</span></a></el-button>
                </el-form-item>
                <el-form-item label="物联网卡号：">
                  <el-upload :disabled="false" ref="uploadContro" class="upload-demo"
                             drag :action="uploadControUrl" multiple :limit="limitNum"
                             accept=".xls,.xlsx" :auto-upload="false"
                             :on-change="this.$upload.onChange"
                             :before-upload="this.$upload.beforeUpload"
                             :on-exceed="this.$upload.onExcced"
                             :on-success="handleSuccess"
                             :headers="headers"
                             :on-error="this.$upload.onError" :file-list="fileList"
                             :data="{cdId:this.card_route.cd_id,controType:this.card_route.cd_control_type,
                             isMaxUse:this.card_route.is_max_use,
                             isLimitRules:this.card_route.is_limit_rules}">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__tip">请上传excel文件</div>
                    <div class="el-upload__text">
                      将文件拖到此处，或
                      <em>点击上传</em>
                    </div>
                  </el-upload>
                </el-form-item>
                <div style="display: flex;">
                  <el-form-item label="控制类型 *">
                    <el-select @change="sel_changeI()" filterable allow-create default-first-option v-model="card_route.cd_control_type" placeholder="请选择">
                      <el-option v-for="item in cd_control_type_option" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="断网阈值 *" v-show="!option_batch">
                    <el-input v-model.trim="card_route.is_max_use" type="number" placeholder="如 50MB 阈值输入：50" />
                  </el-form-item>
                  <el-form-item label="限速规则 *" v-show="option_batch">
                    <el-input v-model.trim="card_route.is_limit_rules" placeholder="如: 10=4,20=1(单位MB)" />
                  </el-form-item>
                  <el-form-item>
                    <el-button style="margin-left: -100%"  type="primary" size="small" plain @click="uploadControExcel">上传</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <div v-show="clickIndex===2">
              <el-form label-width="100px">
                <el-form-item label="卡类型：">
                  <el-button disabled>ICCID</el-button>
                </el-form-item>
                <el-form-item label="物联网卡号：">
                  <el-input type="textarea" :rows="10" style="width:89%;" name="content" id="content" v-model="iccids" placeholder="请输入号码（卡号之间以换行隔开）" />
                </el-form-item>
                <div style="display:flex;">
                  <el-form-item label="通道名称 *">
                    <el-select  clearable filterable allow-create @focus="getChannelList" default-first-option v-model="card_route.cd_id" placeholder="请选择">
                      <el-option v-for="item in card_route_option" :key="item.cd_id" :label="item.cd_name" :value="item.cd_id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="huaka" type="primary" size="small" plain>通道划卡</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <div v-show="clickIndex===3">
              <el-form label-width="100px">
                <el-form-item label="卡类型：">
                  <el-button disabled>ICCID</el-button>
                </el-form-item>
                <el-form-item label="下载模板：">
                  <el-button><a :href="importUrl"><span style="color:#333;">导入模板</span></a></el-button>
                </el-form-item>
                <el-form-item label="物联网卡号：">
                  <el-upload :disabled="false" ref="upload" class="upload-demo" drag
                             :action="uploadUrl" multiple :limit="limitNum" accept=".xls,.xlsx"
                             :auto-upload="false" :on-change="this.$upload.onChange"
                             :before-upload="this.$upload.beforeUpload" :on-exceed="this.$upload.onExcced"
                             :on-success="handleSuccess" :on-error="this.$upload.onError"
                             :file-list="fileList"
                             :headers="headers"
                             :data="{cdId:this.card_route.cd_id,controType:3,
                             isMaxUse:this.card_route.is_max_use,
                             isLimitRules:this.card_route.is_limit_rules}">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__tip">请上传csv或excel文件</div>
                    <div class="el-upload__text">
                      将文件拖到此处，或
                      <em>点击上传</em>
                    </div>
                  </el-upload>
                </el-form-item>
                <div style="display:flex;">
                  <el-form-item label="通道名称 *">
                    <el-select @focus="getChannelList" filterable allow-create default-first-option v-model="card_route.cd_id" placeholder="请选择">
                      <el-option v-for="item in card_route_option" :key="item.cd_id" :label="item.cd_name" :value="item.cd_id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="small" plain @click="uploadCardRoute()" type="primary">上传</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>



<script>
import tools from '../../../utils/tools'
import {aesEncrypt} from '../../../utils/mycrypto'

export default {
  name: 'route_control',
  components: {
    //Pagination,
  },
  mounted: function () {
    this.headers={
      token: sessionStorage.getItem("sys-token"),
      userId: sessionStorage.getItem("loginUser")!==null?JSON.parse(sessionStorage.getItem("loginUser")).id:''
    }
  },
  data() {
    return {
      headers:{},
      card_route_option: [],
      option_bool: null,
      option_batch:null,
      iccids: '',
      cd_control_type_option: [
        { label: '无', value: '0' },
        { label: '限速', value: '1' },
        {label: '达量断网',value: '2'}
      ],
      card_route: {
        cd_control_type: '',
        is_max_use: '',
        is_limit_rules: '',
        cd_id: '',
      },
      limitNum: 0,
      fileList: [],
      uploadUrl: process.env.VUE_APP_SERVER + '/manager/CardRoute/uploadUpdateContro',
      uploadControUrl: process.env.VUE_APP_SERVER + '/manager/CardRoute/uploadUpdateContro',
      importUrl: 'http://' + location.host + '/download/excel/batch.xlsx',
      msg: [
        { id: '1', title: '批量卡通道管控' },
        { id: '2', title: '上传表格通道管控' },
        { id: '3', title: '批量卡通道划卡' },
        { id: '4', title: '上传表格通道划卡' }
      ],
      clickIndex: 0,
      channelJs: require('../../../api/cardRoute')
    }
  },
  methods: {
    huaka(){
      let _this = this
      //获取iccids
      let iccids = tools.textareaGet(_this.iccids)
      if(iccids.length > 1000 ){
        _this.$alert("最多只能输入1000张卡号")
        return false
      }
      if(iccids.length ===0 ){
        _this.$alert("请输入号码")
        return false
      }
      if(_this.card_route.cd_id===''){
        _this.$alert("请选择通道")
        return false
      }
      let data ={
        iccids: iccids,
        controType: '3',
        limitValue: '',
        cdId: _this.card_route.cd_id,
      }
      _this.channelJs.updateContro(data).then(response => {
        if (response.data.code === '0') {
          _this.$alert(response.data.data)
        } else {
          _this.$alert(response.data.msg)
        }
      })
    },
    getChannelList(){
      let that=this
      that.channelJs.getChannelList({currentPage:0,pageSize:999999}).then(response => {
        if (response.data.code === '0') {
          response.data.data.rows.map(item=>{
            let map={}
            map['cd_name'] =item.cdName
            map['cd_id'] =item.cdId
            that.card_route_option.push(map)
          })

        }
      })
    },
    ChangClick(data) {
      let _this = this
      _this.card_route.cd_control_type = ''
      this.clickIndex = data
    },
    funAdd() {
      let _this = this
      let limitValue
      //获取iccids
      let iccids = tools.textareaGet(_this.iccids)
      if(iccids.length > 1000 ){
        _this.$alert("最多只能输入1000张卡号")
        return false
      }
      if(iccids.length ===0 ){
        _this.$alert("请输入号码")
        return false
      }
      if(_this.card_route.cd_control_type==='2' ){
        if(_this.card_route.is_max_use===''){
          _this.$alert("请输入达量断网阈值")
          return false
        }else{
          limitValue = _this.card_route.is_max_use
        }
      }
      if( _this.card_route.cd_control_type==='1'){
        if(_this.card_route.is_limit_rules===''){
          _this.$alert("请输入限速编码")
          return false
        }else{
          limitValue =_this.card_route.is_limit_rules
        }
      }

      let data ={
        iccids: iccids,
        controType: _this.card_route.cd_control_type,
        limitValue: limitValue,
        cdId:''
      }
      _this.channelJs.updateContro(data).then(response => {
        if (response.data.code === '0') {
          _this.$alert(response.data.data)
        } else {
          _this.$alert(response.data.msg)
        }
      })
    },
    sel_changeI() {
      let _this = this
      if (_this.card_route.cd_control_type == 0) {
        _this.option_batch = null
      } else if (_this.card_route.cd_control_type == 1) {
        _this.option_batch = true
      } else if (_this.card_route.cd_control_type == 2) {
        _this.option_batch = false
      }
    },
    sel_change() {
      let _this = this
      if (_this.card_route.cd_control_type == 0) {
        _this.option_bool = null
      } else if (_this.card_route.cd_control_type == 1) {
        _this.option_bool = true
      } else if (_this.card_route.cd_control_type == 2) {
        _this.option_bool = false
      }
    },
    beforeUploadFile(file) {},
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$notify.warning({
        title: '警告',
        message: `只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`
      })
      this.$refs.upload.clearFiles()
      return false
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      let that=this
      if (res.code === '0') {
        that.$alert(res.data)
        this.diaVisImport = false
      } else {
        that.$alert(res.msg)
      }
      this.$refs.upload.clearFiles()
    },

    uploadCardRoute() {
      let _this=this
      if(_this.card_route.cd_id===''){
        _this.$alert("请选择通道")
        return false
      }
      _this.$refs.upload.submit()
    },
    uploadControExcel(){
      let _this=this

      if(_this.card_route.cd_control_type===''){
        _this.$alert("请选择控制类型")
        return false
      }

      if(_this.card_route.cd_control_type==='2' ){
        if(_this.card_route.is_max_use===''){
          _this.$alert("请输入达量断网阈值")
          return false
        }
      }
      if( _this.card_route.cd_control_type==='1'){
        if(_this.card_route.is_limit_rules===''){
          _this.$alert("请输入限速编码")
          return false
        }
      }
      this.$refs.uploadContro.submit()
    }
  }
}
</script>



<style scoped>

  .bgwithe{
    height: 100%;
  }

/*.text-area{
          width: 100%;
          border-top:1px solid gainsboro;
          border-bottom:1px solid gainsboro;

      }
    .text-area textarea {
        width: 100%;
        margin: 0.75rem  0;
        border: none;
        outline: none;
        padding-left: 1.125rem;
        height: 6.5rem ;
    }

    .text-area textarea::-webkit-input-placeholder {
        color: #9E9E9E;

    }*/
</style>
<style >
input[type='file'] {
  display: none !important;
}
.el-upload-dragger {
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 657.19px;
  height: 240px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
</style>
<style scoped>
/deep/.el-upload {
  margin-bottom: 20px !important;
}

/* ------- */
.box {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.left {
  width: 30%;
  display: flex;
  flex-direction: column; /* background-color: red; */
  align-items: center;
}
.leftItem {
  width: 50%;
  border: 1px solid #dcdfe6;
  margin-top: 10px;
  text-align: center;
  border-radius: 5px;
  padding: 4px 0px;
  cursor: pointer;
}
.right1 {
  width: 70%;
  padding: 15px;
  padding-left: 4%;
  margin-left: 2%;
  border: 1px dashed #dcdfe6;
  border-radius: 5px;
  margin-top: 5%;
}
.liBackground {
  background-color: #f5f5f5;
  color: #40a9ff;
  border: 1px solid #6052ff;
}
</style>
